import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/frontend/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/frontend/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/frontend/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"300\",\"400\",\"500\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["DisableDraftMode"] */ "/vercel/path0/web/frontend/src/components/DisableDraftMode.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/frontend/src/components/NavigationContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/web/frontend/src/components/Notification.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/frontend/src/styles/tailwind.css");
;
import(/* webpackMode: "eager", webpackExports: ["IntercomProvider"] */ "/vercel/path0/web/frontend/src/utils/intercom.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/vercel/path0/web/frontend/src/utils/notifications.tsx");
